import React from 'react'
import styles from './MyLoader.module.scss'

interface MyLoaderProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
  variant?: 'spinner' | 'dots' | 'pulse'
  overlay?: boolean
}

const MyLoader = ({
  size = 'md',
  text,
  variant = 'spinner',
  overlay = false,
}: MyLoaderProps) => {
  const sizeClass = styles[size]

  return (
    <div className={`${styles.root} ${overlay ? styles.overlay : ''}`}>
      <div className={styles.loader}>
        {variant === 'spinner' && (
          <div className={`${styles.spinner} ${sizeClass}`}>
            <div className={styles.spinnerTrack} />
            <div className={styles.spinnerFill} />
          </div>
        )}
        {variant === 'dots' && (
          <div className={`${styles.dots} ${sizeClass}`}>
            <span className={styles.dot} />
            <span className={styles.dot} />
            <span className={styles.dot} />
          </div>
        )}
        {variant === 'pulse' && (
          <div className={`${styles.pulse} ${sizeClass}`} />
        )}
        {text && <p className={styles.text}>{text}</p>}
      </div>
    </div>
  )
}

export default MyLoader
